module.exports = __webpack_public_path__ + "img/PMO_Header.a181e844.svg";